import React from 'react';
import './index.css';
import Slider from "../../utils/slider/slider";
import client3 from '../../assets/logo/client3.png';
import client8 from '../../assets/logo/client8.png';
import client9 from '../../assets/logo/client9.png';
import client1 from '../../assets/logo/Nibss-LOG3O-horizontal.png';
import client2 from '../../assets/logo/vigipay.png';
import AddIcon from 'react-icons/lib/md/flight-land';
import Join from  'react-icons/lib/fa/chain';
import Customise from  'react-icons/lib/ti/spanner';
import Upload from  'react-icons/lib/fa/upload';
const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    speed: 2000,
    autoplaySpeed: 5000,
    cssEase: "linear"
};
const Ebips = () => {

    return(
        <div id="ebips" >
        <div className="container-fluid no-pd header">
            <div className="ebipsOverlay"></div>
 <div className="row text-center" style={{padding:"15vw"}}>
     <div className="col-md-12">
       <h4 className="ebipsTitle" style={{color: "white",lineHeight:"1.4"}}>  Automate end-to-end  billing processes.
         EBIPS is the ultimate billing and payment settlement suite; to improve transparency and business accountability,
         which eventually results in increased cash flow as well as better  business intelligence for Ministries, Departments and Agencies.
       </h4>
 </div>

 </div>
        </div>
            <div className="row">
                <div className="col-md-12">
                    <div className="container">
                        <div  className="row text-center pd-40">
                            <div className="col-md-12">
                                <p> EBIPS is the ultimate billing and payment settlement suite; to improve transparency and accountability in your business. </p>
                            </div>
                        </div>
                        <div className="row text-center mb-4 br-bt">
                            <div className="col-md-4 pd-40 br-r text-uppercase">
                                <Join color="rgba(33, 33, 33, 0.54)" size="50"/>
                                <h5 className="mt-3" style={{color:'rgba(33, 33, 33, 0.54)'}}>Easy integration</h5>
                            </div>
                            <div className="col-md-4 pd-40  br-r text-uppercase">
                                <Customise color="rgba(33, 33, 33, 0.54)" size="50"/>
                                <h5 className="mt-3" style={{color:'rgba(33, 33, 33, 0.54)'}}>Easy customization</h5>
                            </div>
                            <div className="col-md-4 pd-40 text-uppercase">
                                <Upload color="rgba(33, 33, 33, 0.54)" size="50"/>
                                <h5 className="mt-3" style={{color:'rgba(33, 33, 33, 0.54)'}}>Easy to deploy</h5>
                            </div>
                        </div>
                        <div className="row text-center pd-40">
                            <div className="col-md-12">
                                <h2> OBJECTIVE OF EBIPS</h2>

                                <p className="mt-3"> To provide African businesses with world class technology suite for billing and settlement automation</p>
                            </div>
                        </div>
                        <div className="row text-center pd-40">
                            <div className="col-md-12">
                                <div className="why">
                                <h2> WHY EBIPS? </h2>

                                <p className="mt-3"> EBIPS helps organisations and agencies solve challenges associated with leakages in revenue earned, transparency, manual invoicing processes,
                                    and lack of cohesive reporting point. </p>
                                </div>
                            </div>
                        </div>
                        <div className="row pd-40">
                            <div className="col-lg-4 col-md-12">
                                <div className="middle">
                                    <div>
                                        <AddIcon color="#172241" size="50"/>
                                        <h2 className="mt-3"> PRODUCTS </h2>
                                <p className="mt-3">Our products are directed toward a future where every organization has access to advanced technology for improved profitability,
                                    cash flow predictability and business insight. </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-8 col-md-12">
                                <div className="products">
                                    <div className="row">
                                        <div className="col-lg-6 col-md-6">

                                            <div className="mb-4">
                                            <h5><b>Central Billing System</b> to ease revenue payment and monitoring for organizations</h5>
                                                <p className="mt-3">

                                            Inspiring  collaboration

                                            EBIPS supports multi-payment platforms to ease the electronic payment method though the issuance of invoice numbers and tracking.
                                            This central viewing feature ensures that managers can view payment status in real time.
                                            </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">

                                            <div className="mb-4">
                                            <h5><b>Electronic Payment System</b> to enhance money transfer between virtual accounts </h5>

                                                <p className="mt-3">
                                            Turning data to cash

                                            By empowering managers and their clients with virtual credit and debit wallets, EBIPS helps businesses across Africa improve cash flow predictability, reducing overall day sales outstanding.
                                            The virtual account contains the history of all transactions indicating the client and the amount due.
                                                </p>
                                            </div>
                                            </div>
                                        <div className="col-lg-6 col-md-6">
                                            <div className="mb-4">

                                            <h5><b>Electronic Invoicing System</b> to enhance account reconciliation for all business transactions  </h5>
                                                <p className="mt-3">
                                            Providing digital transformation

                                            To meet the future challenges, businesses need an adaptive set of skills. EBIPS solutions ensures digital readiness to reconcile the payments they receive from customers against the original invoices they submitted.
                                            This reconciliation rides on the use of AviTech’s  Invoice Tracking technologies.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-lg-6 col-md-6">

                                            <div className="mb-4">
                                            <h5><b>Electronic Billing System </b>to drive paperless mode of transaction for both the receiver and sender of the electronic bill </h5>
                                                <p className="mt-3">
                                            Igniting innovation and excellence

                                            For all organizations, EBIPS can support billing officers and managers operations to eliminate the need for storing paper bills.
                                            This collaborative tool uses Big Data, Business Intelligence, Storage tools and Standard security technologies from AviTech’s Cloud Platform.
                                                </p>
                                            </div>
                                            </div>
                                    </div>
                                </div>

                            </div>
                        </div>
                        <div className="row pd-40">
                            <div className="col-lg-8 col-sm-12 ">
                                        <div className="reconciliation">
                                <p> EBIPS provides businesses with even more ways to easily control and personalize their payment experience – so they can improve collections efficiency</p>
<div>
                                <ul>
                                    <li>Integrated with Remita for TSA payment compliance.</li>

                                    <li>Credit and Debit Wallet System for Prepaid and Post paid clients.</li>

                                    <li> Quick invoice retrieval for all invoices generated on the system.</li>

                                    <li> Reconciles  payments with their respective  invoices, making audit and reconciliation easy.</li>

                                    <li>Eliminates the need for invoice storage on paper which is susceptible to environmental hazard and manipulation.</li>

                                    <li> Blocks revenue leakages from fraudulent activities.</li>
                                </ul>
</div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-sm-12">
                                <div className="middle">
                                    <div>
                                    <AddIcon color="#172241" size="50"/>
                                    <h2 className="mt-3"> RECONCILIATION MADE-EASY! </h2>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row text-center pt-5 mt-5 hr">
                            <div className="col-md-12">
                                <h2> OUR PARTNERS</h2>
                            </div>
                            <div className="col-md-12">
                                <Slider {...settings}>
                                    <div>
                                        <img className='clients-images' src={client3} alt="The Last of us" />
                                    </div>
                                    <div>
                                        <img className='clients-images' src={client8} alt="The Last of us" />
                                    </div>
                                    <div>
                                        <img className='clients-images' src={client9} alt="The Last of us" />
                                    </div>
                                    <div>
                                        <img className='clients-images' src={client1} alt="The Last of us" />
                                    </div>
                                    <div>
                                        <img className='clients-images' src={client2} alt="The Last of us" />
                                    </div>
                                </Slider>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default Ebips



// WEBPACK FOOTER //
// ./src/views/ebips/index.js